/*    
<summary>
  This functional component is used for proper authentication of user using the Login Credentials (Username & Password)
  Developer:Aashish Singh, Created Date:08-Mar-2023
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from "react";
import toast from "react-hot-toast";
import "./Login.css";
import { withRouter } from "react-router-dom";
import RoutesConstants from "../../shared-components/Routes/routes.constants";
import { formatMessage } from "../../translations/format-message";
import { observer } from "mobx-react";
import { useStore } from "../../contexts/StoreProvider";
import Footer from "../../shared-components/Footer/Footer";
import ILogin from "../../models/ILogin";
import { ICommonState } from "../../models/state/ICommonState";
import { useCookies } from "react-cookie";
import { errorMessage } from "../../constants/error.constants";
import LoginForm from "./forms/LoginForm";
import Lottie from "react-lottie";
import monoZlogo from "../../assets/Images/Lottie/monoZLink.json";
import monozlogo from "../../assets/Images/monoZ_Black.png";
import userTypeEnum from "../../constants/user-type-enum";
import { getUserTypeFromLocalStorage } from "../../helpers/local-stotrage-helper";
import StepTwoAuthForm from "./forms/step-two-auth-form";
import FormLoader from "../../shared-components/FormLoader/FormLoader";

const css = `
body, html {
  overflow: visible;
  height: auto;
}
`;
const Login = (props: any) => {
  const { authStore, preferencesStore, tenantStore } = useStore();
  const { getVersion } =
    preferencesStore;
  const {
    resendActivationLinkState,
    resetAccountActivationLink
  } = tenantStore;
  
  localStorage.removeItem("mzl_selected_resend_email");
  const { error, inProgress, isStepTwoVerificationCodeSentState } = authStore;
  const { isAuthenticated, getToken, login, getRoleType, StepOneAuthenticationService,
    isStepOneAuthenticatedState, verifiedUserDetails, resetIsStepOneAuthenticatedState
   } = authStore;
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const emailFromCookies = cookies.user;
  const initialValues: ILogin = {
    email: emailFromCookies !== undefined ? emailFromCookies : "",
    password: "",
    rememberMe: emailFromCookies !== undefined ? true : false,
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: monoZlogo,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const handleStepOneAuthentication = (values: ILogin) => {
    StepOneAuthenticationService(values);
  };
  
  const handleLogin = (values: any) => {
    // if (values.rememberMe === true) {
    //   setCookie("user", values.email);
    // } else {
    //   if (cookies.user != "") {
    //     removeCookie("user");
    //   }
    // }
    login(values);
  };

  useEffect(() => {
    if (isAuthenticated || getToken) {
      toast.success(formatMessage("login_success"))
      resetIsStepOneAuthenticatedState();
      getVersion();
      if (getUserTypeFromLocalStorage() === userTypeEnum.SystemUser)
        props.history.push(RoutesConstants.Tenants);
      else props.history.push(RoutesConstants.Dashboard);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (error) {
      if(error === errorMessage.UserAlreadyLogin){
        props.confirmLoginPopupToggleHandler()
      }
      else{
        toast.error(formatMessage(error));
        authStore.reset();
      }
    }
  }, [error]);

  useEffect(() => {
    if (resendActivationLinkState.success) {
      resetAccountActivationLink();
    }
  }, [resendActivationLinkState.success]);

  return (
    <>
      <div className="bg-img1 text-start background">
        {(props.isLoading || isStepOneAuthenticatedState.inProgress || isStepTwoVerificationCodeSentState.inProgress)  && (
          <FormLoader loading={(props.isLoading || isStepOneAuthenticatedState.inProgress || isStepTwoVerificationCodeSentState.inProgress)} />
        )}
        <div className="login_wrapper">          
          <img src={monozlogo} alt="mono_z_Logo" className="LightSmallLogo" />
          <Lottie options={defaultOptions} height={230} width={790} />            
        </div>
        {
          verifiedUserDetails?.IsTwoFactorEnable  ? 
          <StepTwoAuthForm
            isLoading={inProgress}
            loginHandler={handleLogin}
            initialValues={initialValues}
            email={verifiedUserDetails?.EmailId}
          />  :
          <LoginForm
            isLoading={isStepOneAuthenticatedState.inProgress}
            loginHandler={handleStepOneAuthentication}
            initialValues={initialValues}
          />
        }
      </div>
      <Footer />
    </>
  );
};

export default withRouter(observer(Login));
